import { render, staticRenderFns } from "./hubsChangeBlock.vue?vue&type=template&id=f37e0b86&scoped=true&"
import script from "./hubsChangeBlock.vue?vue&type=script&lang=js&"
export * from "./hubsChangeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37e0b86",
  null
  
)

export default component.exports